
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingBOMGrid extends Serenity.EntityGrid<TreeMakingBOMRow, any> {
        protected getColumnsKey() { return 'Production.TreeMakingBOM'; }
        protected getDialogType() { return TreeMakingBOMDialog; }
        protected getIdProperty() { return TreeMakingBOMRow.idProperty; }
        protected getInsertPermission() { return TreeMakingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return TreeMakingBOMRow.localTextPrefix; }
        protected getService() { return TreeMakingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}